import React, { useEffect, useState } from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import axios from "axios";
import { Link } from 'react-router-dom';
import api, { baseURL } from "../../API/api.url";

const PortfolioView = () => {
  const [portfolios, setPortfolios] = useState([]);

  const getAllPortfolios = async () => {
    try {
      const response = await axios.get(`${baseURL}${api.portfolio.getAllPortfolios.url}`);
        console.log("Portfolios fetched:", response.data);
      if (Array.isArray(response.data)) {
        setPortfolios(response.data);
      } else {
        console.error("Unexpected response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching portfolios:", error);
    }
  };

  useEffect(() => {
    getAllPortfolios();
  }, []);

  return (
    <>
      <Navbar />
      <div className="main-section">
        <div className="portfolio-main py-5">
          <div className="container">
            {/* Show main featured portfolio (first one) */}
            {portfolios.length > 0 && (
                
              <div className="row mb-5">
                 <div className="portfolio-title col-md-8 mx-auto text-center mb-4">
              <span className="text-uppercase text-muted">My Portfolio</span>
              <h2 className="fw-bold">
                A Showcase of Innovation and <b>Excellence</b>
              </h2>
              <p className="mt-3">{portfolios[0].ShortDescription}</p>
            </div>
                <div className="col-md-8 m-auto text-center">
                  <img
                    className="w-100 rounded mb-5 shadow"
                    src={`${baseURL}${portfolios[0].thumbnail}`}
                    alt="Portfolio Banner"
                  />
                  <div>
                    <h2 className="fw-bold text-uppercase">{portfolios[0].AppName}</h2>
                    <p>{portfolios[0].description}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Remaining portfolios in grid */}
            <div className="row g-4">
              {portfolios.map((item, index) => (
                <div className="col-sm-6 col-12 col-md-6 col-lg-4" key={item._id}>
                  <div className="portfolio-img">
                    <img
                      className="w-100 rounded mb-3"
                      src={`${baseURL}${item.thumbnail || item.image?.[0]}`}
                      alt={item.AppName}
                    />
                    <h5 className="fw-semibold mb-0 text-center">{item.AppName}</h5>
                    <p className="text-center small text-muted px-2">{item.ShortDescription}</p>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PortfolioView;
